import { render, staticRenderFns } from "./commissionSettings.vue?vue&type=template&id=5f9285a5&scoped=true&"
import script from "./commissionSettings.vue?vue&type=script&lang=js&"
export * from "./commissionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9285a5",
  null
  
)

export default component.exports